import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type ProjectMembershipHasInefficientRoleErrorOptions = {
  user: ObjectId;
  project: ObjectId;
};

export class ProjectMembershipHasInefficientRoleError extends FleekError<ProjectMembershipHasInefficientRoleErrorOptions> {
  public name = 'ProjectMembershipHasInefficientRoleError';

  toString = () => `Membership has inefficient role for this action.`;
}
